export const staticStyles = {
  wrapper: {
    display: 'flex',
    alignItems: 'center',
    alignContent: 'center',
    justifyContent: 'center',
    flexWrap: 'wrap',
    padding: '0 40px',
    width: '100%',
    height: '100%',
    flex: '1 1 auto',
  },
  noHistory: {
    padding: '0 40px 0 15px',
  },
  title: {
    fontSize: 12,
    fontWeight: 500,
    textTransform: 'uppercase',
    letterSpacing: '0.2px',
    overflow: 'hidden',
    textOverflow: 'ellipsis',
  },
  description: {
    margin: '12px 0 0',
    maxWidth: '327px',
    fontSize: 12,
    display: '-webkit-box',
    maxHeight: '30px',
    lineHeight: '15px',
    WebkitLineClamp: 2,
    WebkitBoxOrient: 'vertical',
    overflow: 'hidden',
    textOverflow: 'ellipsis',
  },
  infoWrap: {
    display: 'flex',
    flexDirection: 'column',
    flex: '1 1 0',
    margin: '0 8px',
  },
  avatar: {
    position: 'relative',
  },
  infoWrapExpanded: {
    display: 'flex',
    flexDirection: 'column',
    width: '100%',
    alignItems: 'center',
    marginTop: '6px',
    marginBottom: '5px',
    textAlign: 'center',
  },
  descriptionExpanded: {
    marginTop: '24px',
    maxWidth: '327px',
    textAlign: 'center',
  },
  waitMessage: {
    fontSize: 13,
    marginTop: '4px',
  },
};

export const start = props => {
  if (props.expanded) {
    return {
      titleFontSize: 11,
      titleMarginTop: 11,

      descriptionFontSize: 12,
      descriptionMarginTop: 12,
      avatarWidth: 42,
      avatarTop: 5,
    };
  }

  return {
    avatarTop: 0,
    descriptionMarginTop: 12,
  };
};

export const end = props => {
  if (props.expanded) {
    return {
      titleFontSize: 11,
      titleMarginTop: 11,

      descriptionFontSize: 12,
      descriptionMarginTop: 12,
      avatarWidth: 300,
    };
  }

  return {
    titleFontSize: 12,
    titleMarginTop: 0,

    descriptionFontSize: 11,
    descriptionMarginTop: 4,
    avatarWidth: 42,
    avatarTop: 0,
    infoWrapMarginLeft: 12,
  };
};

export const tween = values => {
  return {
    wrapper: {},
    title: {
      fontSize: `${values.titleFontSize}px`,
      marginTop: `${values.titleMarginTop}px`,
    },
    description: {
      fontSize: `${values.descriptionFontSize}px`,
      marginTop: `${values.descriptionMarginTop}px`,
    },
    avatar: {
      width: `${values.avatarWidth}px`,
      top: `${values.avatarTop}px`,
    },
  };
};
